import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

type ButtonColors =
	| 'none'
	| 'primary'
	| 'secondary'
	| 'tertiary'
	| 'success'
	| 'danger'
	| 'light'
	| 'medium'
	| 'dark'
	| 'ghost'
	| 'gray'
	| 'grey';

interface BasicButtonProps {
	color?: ButtonColors;
	bordered?: boolean;
	filled?: boolean; // whether the background is filled or not
	blocked?: boolean;
	uppercase?: boolean;
	disabled?: boolean;
	rounded?: boolean;
	size?: 'small' | 'default' | 'medium' | 'large' | 'none';
	tag?: 'button' | 'div';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicButton',
  props: {
    color: { default: 'secondary' },
    bordered: { type: Boolean },
    filled: { type: Boolean, default: true },
    blocked: { type: Boolean },
    uppercase: { type: Boolean },
    disabled: { type: Boolean },
    rounded: { type: Boolean, default: true },
    size: { default: 'default' },
    tag: { default: 'button' }
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props as { color: ButtonColors, bordered?: boolean, filled: boolean, blocked?: boolean, uppercase?: boolean, disabled?: boolean, rounded: boolean, size: 'small' | 'default' | 'medium' | 'large' | 'none', tag: 'button' | 'div' };





const type = computed(() => (props.tag === 'button' ? 'button' : undefined));
const isDisabled = computed(() => (props.tag === 'button' ? props.disabled : undefined));

const classes = computed(() => {
	return {
		// colors
		primary: props.color === 'primary',
		secondary: props.color === 'secondary',
		tertiary: props.color === 'tertiary' || props.color === 'dark',
		light: props.color === 'light',
		medium: props.color === 'medium',
		ghost: props.color === 'ghost',
		grey: props.color === 'gray' || props.color === 'grey',

		// size
		sm: props.size === 'small',
		md: props.size === 'default',
		md24: props.size === 'medium',
		lg: props.size === 'large',

		border: props.bordered,
		'w-full': props.blocked,
		'bg-none': !props.filled,
		uppercase: props.uppercase,
		rounded: props.rounded,
		disabled: props.disabled,
		'pointer-events-none': props.disabled,
	};
});

return { __sfc: true,props, type, isDisabled, classes }
}

})